import {h, Component} from 'preact';
export default class History extends Component {
    render() {
        return (
            <svg viewBox="0 0 64 64" fill={this.props.color}><path d="M48,18.25a28,28,0,0,0-37.63-1.79l.94-4.79a1.42,1.42,0,1,0-2.78-.54L6.69,20.26A1.42,1.42,0,0,0,8.08,22h0l9.32,0a1.42,1.42,0,0,0,0-2.84h0l-5.81,0A25.17,25.17,0,0,1,46,55.85a1.42,1.42,0,1,0,2,2,28,28,0,0,0,0-39.6Z"/><path d="M29,22.06a16,16,0,1,0,16,16A16,16,0,0,0,29,22.06ZM29,51a13,13,0,1,1,13-13A13,13,0,0,1,29,51Z"/><path d="M34.61,37H30V29.41a1.48,1.48,0,0,0-3,0v9.07A1.48,1.48,0,0,0,28.49,40h6.12a1.47,1.47,0,1,0,0-2.95Z"/></svg>
        );
    }
}



// WEBPACK FOOTER //
// ./components/SVGImages/History.js